import React, { useState,useEffect } from 'react'
import { useFormInputValidation } from "react-form-input-validation";
import { useNavigate,Link } from 'react-router-dom';
import {signUp} from '../../api/apiHandler'

export default function SignUp() {
    const navigate=useNavigate()

const [fields, errors, form] = useFormInputValidation({
    full_name: "",
    email: "",
    password: "",
    phone_number: "",
}, {
    full_name: "required",
    email: "required|email",
    password: "required",
    phone_number: "required",
});

const onSubmit = async (event) => {
    event.preventDefault();
    const isValid = await form.validate(event);
    if (isValid) {
      signUpAPI()
    }
  }

  // Sign up API calling 
  const signUpAPI=()=>{
    signUp(fields).then((resposnse)=>{
        if(resposnse.data.code==1){
            navigate('/otp-verification', { state: { email: fields.email, donor_id: resposnse.data.data.id } })
        }else{
            
        }
    }); 
  }

return (
<div className="authentication">
    <div className="card">
        <div className="body">
            <div className="row">
                <div className="col-lg-12">
                    <div className="header slideDown">
                        <div className="logo"><img src={process.env.PUBLIC_URL+"/assets/images/logo-2.png"} alt="Nexa"/></div>
                        <h1>Donor Panel</h1>
                    </div>                        
                </div>
                <form className="col-lg-12" id="form_validation" noValidate autoComplete="off" onSubmit={onSubmit} method="" action='#' >
                    <h5 className="title">Create an Account</h5>
                    <div className="form-group form-float">
                        <div className="form-line">
                            <input type="text" className="form-control" placeholder='Full Name' id="full_name" name="full_name" 
                            onBlur={form.handleBlurEvent}
                            onChange={form.handleChangeEvent}
                            value={fields.full_name}/>
                        </div>
                        <label className="errorc" >{errors.full_name? errors.full_name: ""}</label>
                    </div>
                    <div className="form-group form-float">
                        <div className="form-line">
                            <input type="text" className="form-control" placeholder='Email' id="email" name="email" 
                            onBlur={form.handleBlurEvent}
                            onChange={form.handleChangeEvent}
                            value={fields.email}/>
                        </div>
                        <label className="errorc" >{errors.email? errors.email: ""}</label>
                    </div>
                    <div className="form-group form-float">
                        <div className="form-line">
                            <input type="password" className="form-control" placeholder='Password' id="password" name="password" 
                              onBlur={form.handleBlurEvent}
                              onChange={form.handleChangeEvent}
                              value={fields.password}
                            />
                        </div>
                        <label className="errorc">{errors.password? errors.password: ""}</label>
                    </div>
                    <div className="form-group form-float">
                        <div className="form-line">
                            <input type="text" className="form-control" placeholder='Phone Number' id="phone_number" name="phone_number" 
                              onBlur={form.handleBlurEvent}
                              onChange={form.handleChangeEvent}
                              value={fields.phone_number}
                            />
                        </div>
                        <label className="errorc">{errors.phone_number? errors.phone_number: ""}</label>
                    </div>
                    <div className="col-lg-12">
                        <button className="btn btn-raised btn-primary waves-effect" type="submit">SIGN UP</button>
                        &nbsp;
                        &nbsp;
                        <Link to="/sign-in" className="btn btn-raised btn-info waves-effect" type="submit">SIGN IN</Link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
  )
}
